module.exports = __webpack_public_path__ + "img/persistence-dark.c758c2d7.svg";